import React from "react";
import { motion } from "framer-motion";
import AppWrap from "../../wrapper/AppWrap";

const skills = [
  {
    category: "Frontend",
    technologies: ["React", "Next.js", "TypeScript", "Tailwind", "Framer Motion"],
  },
  {
    category: "Backend",
    technologies: ["Node.js", "Express", "Spring Boot"],
  },
  {
    category: "Databases",
    technologies: ["PostgreSQL", "MongoDB", "MySQL"],
  },
  {
    category: "Auth & Security",
    technologies: ["JWT", "NextAuth", "Clerk", "RBAC"],
  },
  {
    category: "DevOps & Hosting",
    technologies: ["Vercel", "Railway", "Supabase", "Docker"],
  },
  {
    category: "Product Tools",
    technologies: ["Figma", "Storybook", "Postman", "Linear"],
  },
];

const featured = [
  { title: "Design systems", detail: "Reusable UI kits, tokens, and accessible patterns for fast shipping." },
  { title: "Performance", detail: "Audit, profiling, and caching to keep interactions snappy." },
  { title: "DX", detail: "Clean architecture, typed APIs, and clear docs for maintainable teams." },
];

const Skills = () => {
  return (
    <section className="space-y-10">
      <div className="flex flex-col gap-3">
        <p className="text-sm uppercase tracking-[0.3em] text-primary">Stack & tooling</p>
        <h2 className="text-3xl sm:text-4xl font-bold text-white">What I build with.</h2>
        <p className="text-slate-300 max-w-3xl">
          Modern tooling for fast, reliable shipping. I favor frameworks and services that reduce friction while keeping
          codebases clean.
        </p>
      </div>

      <div className="grid gap-8 lg:grid-cols-[1.2fr_0.8fr]">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="rounded-3xl border border-white/10 bg-white/5 backdrop-blur-xl shadow-2xl p-6 sm:p-8"
        >
          <div className="grid gap-6 sm:grid-cols-2">
            {skills.map((block) => (
              <div key={block.category} className="space-y-2">
                <p className="text-xs uppercase tracking-[0.2em] text-slate-400">{block.category}</p>
                <div className="flex flex-wrap gap-2">
                  {block.technologies.map((tech) => (
                    <span
                      key={tech}
                      className="px-3 py-1 rounded-full text-sm bg-white/5 border border-white/10 text-slate-100"
                    >
                      {tech}
                    </span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="rounded-3xl border border-white/10 bg-gradient-to-br from-primary/20 via-primaryDark/10 to-transparent backdrop-blur-xl shadow-2xl p-6 sm:p-8"
        >
          <p className="text-xs uppercase tracking-[0.25em] text-slate-300 mb-4">Approach</p>
          <div className="space-y-5">
            {featured.map((item) => (
              <div key={item.title} className="p-4 rounded-2xl bg-white/5 border border-white/10">
                <h4 className="text-lg font-semibold text-white">{item.title}</h4>
                <p className="text-slate-300 text-sm mt-1">{item.detail}</p>
              </div>
            ))}
          </div>

        </motion.div>
      </div>
    </section>
  );
};

export default AppWrap(Skills, "skills");
